module.exports = __webpack_public_path__ + "img/transportation.d56bcf18.webp";